import IFileType, { VIFileType } from './IFileType';
import IFlag, { VIFlag } from './Flags/IFlag';
import ErrorCodes from '../Error/ErrorCodes';
import ErrorCodesMessages from '../Error/ErrorCodesMessages';

/**
 * Interface represents a file that can be saved to cache and loaded into applet resources.
 */
interface ISaveFile {
	/** Unique identifier for the file. This is used to reference the file in the applet. */
	uid: string;
	/** URI of the file to be saved. */
	uri: string;
	/** Type of the file, e.g. 'javascript', 'css', etc. */
	type: IFileType;
	/** HTTP headers to be sent with the request for the file. */
	headers?: { [key: string]: string };
	/** Additional flags for appending stored files to the DOM or other operations. */
	flags?: IFlag[];
}
export default ISaveFile;

export const VISaveFile = {
	uid: {
		string: null,
		error: {
			code: ErrorCodes.FILE_DOES_NOT_HAVE_UID,
			message: ErrorCodesMessages[ErrorCodes.FILE_DOES_NOT_HAVE_UID],
		},
	},
	uri: 'string',
	type: {
		string: VIFileType,
		error: {
			code: ErrorCodes.FILE_FLAGS_ARE_NOT_IN_ARRAY,
			message: ErrorCodesMessages[ErrorCodes.FILE_FLAGS_ARE_NOT_IN_ARRAY],
		},
	},
	headers: '?object',
	flags: {
		'?array': {
			object: VIFlag,
			error: { code: ErrorCodes.FILE_FLAG_IS_NOT_OBJECT, message: ErrorCodesMessages[ErrorCodes.FILE_FLAG_IS_NOT_OBJECT] },
		},
	},
};
